var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 36C28.3888 36 36 28.3888 36 19C36 9.61116 28.3888 2 19 2C9.61116 2 2 9.61116 2 19C2 28.3888 9.61116 36 19 36Z",
    fill: "url(#paint0_linear_10048_1690)",
    stroke: "white",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58605 19.7337C11.3396 18.7678 13.2969 17.9617 15.1258 17.1515C18.2722 15.8243 21.4311 14.5202 24.6218 13.3061C25.2426 13.0992 26.3581 12.897 26.4674 13.817C26.4074 15.1192 26.1612 16.4138 25.9922 17.7085C25.5633 20.5555 25.0674 23.3927 24.5841 26.2303C24.4174 27.1755 23.2334 27.6648 22.4758 27.06C20.6551 25.83 18.8203 24.6122 17.0228 23.3537C16.4341 22.7555 16.9801 21.8962 17.5058 21.469C19.0054 19.9911 20.5958 18.7355 22.0171 17.1812C22.4004 16.2555 21.2677 17.0357 20.8941 17.2748C18.8411 18.6896 16.8383 20.1907 14.6738 21.4341C13.5682 22.0427 12.2796 21.5226 11.1744 21.1828C10.1836 20.7727 8.73155 20.3593 9.58593 19.7338L9.58605 19.7337Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10048_1690",
    x1: 24.0012,
    y1: 9.001,
    x2: 16.5012,
    y2: 26.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.4ce3b6a71b7dc4bb5024b2c33275769b.svg";
export { ForwardRef as ReactComponent };